import { observer } from 'mobx-react-lite'
import { type ReactNode } from 'react'
import { Box, Icon, SpinnerLoader, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type ISelectConnectionTriggerProps = {
  isLoading: boolean
  isValueSelected: boolean
  placeholder: string
  triggerContent?: ReactNode
}
export const SelectValueTrigger = observer(
  ({ isLoading, isValueSelected, placeholder, triggerContent }: ISelectConnectionTriggerProps) => {
    const content = () => {
      if (isLoading) {
        return (
          <div className={styles.loaderTrigger}>
            <SpinnerLoader ariaLabel={'SelectValueTrigger'} size={12} />
          </div>
        )
      }

      if (!isValueSelected) {
        return (
          <Typography
            ariaLabel='Empty value'
            variant={'text-input-field-r'}
            color='var(--content-primary-disabled)'
          >
            {placeholder}
          </Typography>
        )
      }
      return (
        triggerContent || (
          <Box display={'flex'} alignItems={'center'} gap={1}>
            <Icon icon={'calendly'} fontSize={14} />
            <Typography variant={'text-input-field-r'} ariaLabel={'Calendly_connected'}>
              Calendly
            </Typography>
          </Box>
        )
      )
    }

    return <div>{content()}</div>
  }
)
